/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocio } from '../../conexiones';
import IResolucionesFacturaciones from './entidades/resolucionesFacturaciones';

export default class ModeloResolucionesFacturaciones {
    public consultarResolucionesFacturaciones() {
        return manejadorRest<IRespuesta<IResolucionesFacturaciones>>(() =>
            negocio.get('ResolucionesFacturaciones/ConsultarListaResolucionesFacturaciones')
        );
    }
    public crearResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        return manejadorRest<IRespuesta<IResolucionesFacturaciones>>(() =>
            negocio.post('ResolucionesFacturaciones/GuardarResolucionesFacturaciones', resolucionesFacturaciones)
        );
    }
    public editarResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        return manejadorRest<IRespuesta<IResolucionesFacturaciones>>(() =>
            negocio.put('ResolucionesFacturaciones/EditarResolucionesFacturaciones', resolucionesFacturaciones)
        );
    }
    public eliminarResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        return manejadorRest<IRespuesta<IResolucionesFacturaciones>>(() =>
            negocio.delete('ResolucionesFacturaciones/EliminarResolucionesFacturaciones', resolucionesFacturaciones)
        );
    }
}
